module.exports = require('./helpers/bundle-url').getBundleURL('15MIF') + "aboutSite.371760e3.png";